import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { MaquinasEquipamentosDTO, PerguntaEnergiaDTO, QuestionarioAvaliacaoProjetoDTO, RetornoMensagemSimplesDTO } from '../model/questionario.model';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
const options: any = blockUi();

@Injectable({
  providedIn: 'root'
})
export class QuestionarioService extends FgiBackEndService<QuestionarioAvaliacaoProjetoDTO> {

  getNewEntity():QuestionarioAvaliacaoProjetoDTO {
    return new QuestionarioAvaliacaoProjetoDTO();
  }

  // @Override
  protected getResourceURL(): string {
    return 'public/front/questionario-energia';
  }

  public getPerguntasFaseAvaliacao(): Observable<Array<PerguntaEnergiaDTO>> {
    return this.http.get(`${this.BASE_URL}/perguntas/fase-avaliacao`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<PerguntaEnergiaDTO>>;
  }

  public getPerguntasFaseComplementar(): Observable<Array<PerguntaEnergiaDTO>> {
    return this.http.get(`${this.BASE_URL}/perguntas/fase-complementar`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<PerguntaEnergiaDTO>>;
  }
  
  public getPerguntasFaseEconomia(): Observable<Array<PerguntaEnergiaDTO>> {
    return this.http.get(`${this.BASE_URL}/perguntas/fase-economia`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<PerguntaEnergiaDTO>>;
  }

  public validaQuestionario(questionario: QuestionarioAvaliacaoProjetoDTO, apenasFaseAvaliacao: boolean ): Observable<RetornoMensagemSimplesDTO> {
    this.limpaRespostasNaoAplicaveisQuestionario(questionario);
    return this.http.post(`${this.BASE_URL}/validar?apenasFaseAvaliacao=${apenasFaseAvaliacao}`, questionario).pipe(
        catchError((e) => this.handleError(e))) as Observable<RetornoMensagemSimplesDTO>;
  }

  public salvaRascunho(questionario: QuestionarioAvaliacaoProjetoDTO): Observable<QuestionarioAvaliacaoProjetoDTO> {
    this.limpaRespostasNaoAplicaveisQuestionario(questionario);
    return this.http.post(`${this.BASE_URL}/rascunho`, questionario).pipe(
        catchError((e) => this.handleError(e))) as Observable<QuestionarioAvaliacaoProjetoDTO>;
  }

  public submeterQuestionario(questionario: QuestionarioAvaliacaoProjetoDTO): Observable<QuestionarioAvaliacaoProjetoDTO> {
    this.limpaRespostasNaoAplicaveisQuestionario(questionario);
    return this.http.post(`${this.BASE_URL}/submeter`, questionario).pipe(
        catchError((e) => this.handleError(e))) as Observable<QuestionarioAvaliacaoProjetoDTO>;
  }

  public getQuestionarioAvaliacaoByRascunho(idRascunho: string): Observable<QuestionarioAvaliacaoProjetoDTO> {
    return this.http.get(`${this.BASE_URL}/rascunho/${idRascunho}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<QuestionarioAvaliacaoProjetoDTO>;
  }

  public getQuestionarioAvaliacaoByToken(token: string): Observable<QuestionarioAvaliacaoProjetoDTO> {
    return this.http.get(`${this.BASE_URL}/${token}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<QuestionarioAvaliacaoProjetoDTO>;
  }

  // consulta pela API protegida
  public getQuestionariosAvaliacao(params?: any): Observable<ResultadoPaginado<QuestionarioAvaliacaoProjetoDTO>> {
    return this.http.get(`rest/front/questionario-energia`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<QuestionarioAvaliacaoProjetoDTO>>;
  }
// exclusão feita pela API protegida
  public excluirQuestionario(idQuestionario: number): Observable<QuestionarioAvaliacaoProjetoDTO> {
    return this.http.post(`rest/front/questionario-energia/${idQuestionario}`, {}).pipe(
      catchError((e) => this.handleError(e))) as Observable<QuestionarioAvaliacaoProjetoDTO>;
  }

  public buscarQuestionariosEnviados(): Observable<ResultadoPaginado<QuestionarioAvaliacaoProjetoDTO>> {
    const options = blockUi()
    return this.http.get(`front/FGE/questionario-energia/`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<QuestionarioAvaliacaoProjetoDTO>>;
  }
  /**
   * Limpa as respostas do questionário que não devem ser persistidas ou validadas, geralmente contém a opção de resposta -1 (não aplicável)
   * @param questionario
   */
  private limpaRespostasNaoAplicaveisQuestionario(questionario: QuestionarioAvaliacaoProjetoDTO) {
      questionario.listaResposta.forEach(resp => {
        if (resp.conteudo == "-1") {
            resp.conteudo = ""
        }
      });

  }

  public aprovarQuestionario(id: number) : Observable<void> {
    const options = blockUi();
    return this.http.post<void>(`rest/front/questionario-energia/aprovar/${id}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<void>;    
  }
  
  public reprovarQuestionario(id: number, texto: string) : Observable<void> {
    const options = blockUi();
    return this.http.post<void>(`rest/front/questionario-energia/reprovar/${id}`, { texto, ...options }).pipe(
      catchError((e) => this.handleError(e))) as Observable<void>;    
  }

    public getListaMaquinasEquipamentos(): Observable<Array<MaquinasEquipamentosDTO>> {
    return this.http.get(`${this.BASE_URL}/perguntas/listarMaquinasEquipamentos`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<MaquinasEquipamentosDTO>>;
  }

}
